module.exports = __webpack_public_path__ + "img/card-4.8be0167e.png";